/**
 * When true, the core frontend does not fetch or enforce user permission actions.
 * Users can use the app even when the API returns an empty `allowed_actions` array.
 * Set to false to restore API-driven permission checks.
 */
export const CORE_FRONTEND_PERMISSIONS_DISABLED = true;
